import Hidden from "@mui/material/Hidden";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import {
  CardTitle,
  ContentStyle,
  DataGridListStyle,
  ScrollBarStyle,
} from "../../Theme";
import { v4 as uuid } from "uuid";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { useEffect, useState } from "react";
import { PendingRefillsCount } from "../../Apis/AuthApiServices";
import NoRecords from "../../components/NoRecords";
import { TextOnly } from "../../components/Content";
import { flushSync } from "react-dom";

const columnsPendingRefills: GridColDef[] = [
  {
    field: "patientName",
    headerName: "Details",
    width: 150,
    cellClassName: "w25",
    headerClassName: "w25",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
  {
    field: "refillCount",
    headerName: "Refill(s)",
    width: 100,
    cellClassName: "w10",
    headerClassName: "w10",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
  {
    field: "address",
    headerName: "Address",
    width: 200,
    cellClassName: "w40",
    headerClassName: "w40",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
  {
    field: "contactInfo",
    headerName: "Contact",
    width: 100,
    cellClassName: "w15",
    headerClassName: "w15",
    renderCell: (params: any) => <TextOnly Text={params.value} />,
  },
];
export const rowstData = [
  {
    id: 1,
    details: "",
    refills: 0,
    address: "",
    contact: 0,
  },
];

export default function PendingRefills() {
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const primaryDoctor = localStorage.getItem("DoctorName");
  const [isPrinting, setIsPrinting] = useState(false);
  useEffect(() => {
    function handleBeforePrint() {
      flushSync(() => {
        setIsPrinting(true);
      });
    }

    function handleAfterPrint() {
      setIsPrinting(false);
    }

    window.addEventListener("beforeprint", handleBeforePrint);
    window.addEventListener("afterprint", handleAfterPrint);
    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, []);
  let MessagePresent;
  if (message === "") {
    MessagePresent = (
      <>
        <ScrollBarStyle className="full">
          <Grid
            container
            xs={12}
            spacing={1}
            alignItems="top"
            justifyContent="center"
          >
            {data?.map((item: any, index: any) => (
              <>
                <Grid item xs={12}>
                  <CardTitle
                    className={
                      primaryDoctor === item?.doctorName
                        ? "primary"
                        : "secondary"
                    }
                  >
                    <Typography component="div" variant="body2">
                      {item?.doctorName}
                    </Typography>
                  </CardTitle>
                </Grid>
                <Grid item xs={12}>
                  {isPrinting ? (
                    <DataGridListStyle
                      className="refills"
                      style={{
                        height: `${item?.refillsBodyList?.length * 49}px`,
                      }}
                    >
                      <DataGrid
                        rows={item?.refillsBodyList ?? []}
                        headerHeight={1}
                        sortingOrder={["desc", "asc"]}
                        columns={columnsPendingRefills}
                        autoHeight
                        getRowId={(row) => row.patientId ?? uuid()}
                        rowHeight={45}
                        getRowHeight={() => "auto"}
                        // pageSize={4}
                        // rowsPerPageOptions={[4]}
                        hideFooter={true}
                        disableSelectionOnClick
                        components={{
                          NoRowsOverlay: NoRecords,
                          NoResultsOverlay: NoRecords,
                        }}
                        onRowClick={({ row }) => {
                          navigate(
                            "/pendingrefillsrequest"
                            // , {
                            //   state: {
                            //     rowData: row,
                            //   },
                            // }
                          );

                          sessionStorage.setItem("patientId", row.patientId);
                          localStorage.setItem(
                            "pendingrefillsrequest-data",
                            JSON.stringify(row)
                          );
                        }}
                      />
                    </DataGridListStyle>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Hidden mdDown>
                          <DataGridListStyle className="refills">
                            <DataGrid
                              rows={item?.refillsBodyList ?? []}
                              headerHeight={0}
                              sortingOrder={["desc", "asc"]}
                              columns={columnsPendingRefills}
                              autoHeight
                              getRowId={(row) => row.patientId ?? uuid()}
                              rowHeight={45}
                              // pageSize={4}
                              // rowsPerPageOptions={[4]}
                              hideFooter={true}
                              disableSelectionOnClick
                              components={{
                                NoRowsOverlay: NoRecords,
                                NoResultsOverlay: NoRecords,
                              }}
                              onRowClick={({ row }) => {
                                navigate(
                                  "/pendingrefillsrequest"
                                  // , {
                                  //   state: {
                                  //     rowData: row,
                                  //   },
                                  // }
                                );
                                sessionStorage.setItem(
                                  "patientId",
                                  row.patientId
                                );
                                localStorage.setItem(
                                  "pendingrefillsrequest-data",
                                  JSON.stringify(row)
                                );
                              }}
                            />
                          </DataGridListStyle>
                        </Hidden>
                        <Hidden mdUp>
                          <DataGridListStyle className="refills">
                            <DataGrid
                              rows={item?.refillsBodyList ?? []}
                              headerHeight={36}
                              sortingOrder={["desc", "asc"]}
                              columns={columnsPendingRefills}
                              autoHeight
                              getRowId={(row) => row.patientId ?? uuid()}
                              rowHeight={45}
                              // pageSize={4}
                              // rowsPerPageOptions={[4]}
                              hideFooter={true}
                              disableSelectionOnClick
                              components={{
                                NoRowsOverlay: NoRecords,
                                NoResultsOverlay: NoRecords,
                              }}
                              onRowClick={({ row }) => {
                                navigate(
                                  "/pendingrefillsrequest"
                                  // , {
                                  //   state: {
                                  //     rowData: row,
                                  //   },
                                  //}
                                );
                                localStorage.setItem(
                                  "pendingrefillsrequest-data",
                                  JSON.stringify(row)
                                );
                              }}
                            />
                          </DataGridListStyle>
                        </Hidden>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            ))}
          </Grid>
        </ScrollBarStyle>
      </>
    );
  } else {
    MessagePresent = (
      <>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          style={{ height: 200 }}
        >
          <Typography
            fontWeight={"bold"}
            fontStyle={"italic"}
            color={"primary"}
          >
            {message}
          </Typography>
        </Grid>
      </>
    );
  }

  const getPendingRefillsCount = async () => {
    try {
      const params = new URLSearchParams();
      const doctorId: any = localStorage.getItem("doctorId");
      params.append("doctorId", doctorId);
      params.append("pageNumber", "0");
      const result: any = await PendingRefillsCount(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response[0]?.items);
      } else {
        setData([]);
        setMessage("No Records Found");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
      setMessage("Try Again After Some Time!");
    }
  };
  useEffect(() => {
    getPendingRefillsCount();
  }, []);
  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Pending Refills
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  This section displays requests for drug refills from
                  pharmacies.
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Grid
            container
            item
            xs={12}
            spacing={1}
            alignItems="top"
            justifyContent="center"
          >
            <Grid item xs={12}>
              {isPrinting ? (
                <DataGridListStyle className="title">
                  <DataGrid
                    rows={rowstData}
                    headerHeight={36}
                    columns={columnsPendingRefills}
                    autoHeight
                    rowHeight={40}
                    pageSize={0}
                    rowsPerPageOptions={[0]}
                    hideFooter={true}
                  />
                </DataGridListStyle>
              ) : (
                <Hidden mdDown>
                  <DataGridListStyle className="title">
                    <DataGrid
                      rows={rowstData}
                      headerHeight={36}
                      columns={columnsPendingRefills}
                      autoHeight
                      rowHeight={40}
                      pageSize={0}
                      rowsPerPageOptions={[0]}
                      hideFooter={true}
                    />
                  </DataGridListStyle>
                </Hidden>
              )}
              {MessagePresent}
            </Grid>
          </Grid>
        )}
      </ContentStyle>
    </>
  );
}
